import { checkIsGoogleMap } from 'entities/map';

import { waypointMarkerFactory as WaypointMarkerFactory } from './types/waypointMarkerFactory';
import GoogleWaypointMarker from './GoogleWaypointMarker';

const waypointMarkerFactory: WaypointMarkerFactory = (map, params) => {
  if (checkIsGoogleMap(map.name)) {
    return new GoogleWaypointMarker(map, params);
  }

  throw Error('There is no a waypoint marker for such a map');
};

export default waypointMarkerFactory;
